var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _circle, _path5, _path6, _circle2, _path7, _path8, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 874,
    height: 200,
    viewBox: "0 0 874 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.182 188.481C200.368 188.481 190.826 185.698 182.556 180.131C174.286 174.565 167.845 167.09 163.233 157.707C158.62 148.165 156.314 137.43 156.314 125.502C156.314 113.097 159.018 102.044 164.425 92.3429C169.833 82.4826 177.466 74.6898 187.327 68.9645C197.346 63.2391 209.115 60.3765 222.633 60.3765C236.31 60.3765 247.92 63.2391 257.462 68.9645C267.163 74.5308 274.559 82.2441 279.648 92.1044C284.896 101.806 287.52 112.7 287.52 124.786V174.636C287.52 180.701 282.603 185.618 276.538 185.618H261.04C255.639 185.618 251.26 181.239 251.26 175.837V166.65C251.26 166.322 250.994 166.057 250.666 166.057V166.057C250.444 166.057 250.242 166.18 250.138 166.376C247.936 170.544 245.129 174.334 241.717 177.746C238.219 181.086 233.925 183.71 228.835 185.618C223.905 187.527 218.021 188.481 211.182 188.481ZM222.156 156.514C227.722 156.514 232.573 155.163 236.708 152.459C241.002 149.596 244.262 145.7 246.488 140.77C248.715 135.84 249.828 130.353 249.828 124.309C249.828 118.425 248.715 113.097 246.488 108.326C244.262 103.555 241.002 99.8177 236.708 97.114C232.573 94.2514 227.722 92.82 222.156 92.82C216.43 92.82 211.421 94.2514 207.127 97.114C202.833 99.8177 199.573 103.555 197.346 108.326C195.12 113.097 194.006 118.425 194.006 124.309C194.006 130.353 195.12 135.84 197.346 140.77C199.573 145.7 202.833 149.596 207.127 152.459C211.421 155.163 216.43 156.514 222.156 156.514Z",
    fill: "#052973"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M473.31 185.616C463.109 185.616 454.84 177.347 454.84 167.146V131.203C454.84 121.002 463.109 112.732 473.31 112.732V112.732C483.511 112.732 491.781 121.002 491.781 131.203V167.146C491.781 177.347 483.511 185.616 473.31 185.616V185.616Z",
    fill: "#052973"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M533.215 185.618C523.014 185.618 514.744 177.348 514.744 167.147V108.241C514.744 98.0401 523.014 89.7705 533.215 89.7705V89.7705C543.416 89.7705 551.685 98.0401 551.685 108.241V167.147C551.685 177.348 543.416 185.618 533.215 185.618V185.618Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M317.057 168.645C313.197 168.645 310.068 165.516 310.068 161.656V115.244C310.068 105.066 312.533 95.8417 317.464 87.5718C322.394 79.3019 329.391 72.7018 338.456 67.7717C347.681 62.8415 358.575 60.3765 371.139 60.3765C383.862 60.3765 394.676 62.8415 403.582 67.7717C412.647 72.7018 419.565 79.3019 424.336 87.5718C429.108 95.8417 431.493 105.066 431.493 115.244V161.656C431.493 165.516 428.364 168.645 424.504 168.645L413.005 168.645L401.506 168.645C397.646 168.645 394.517 165.516 394.517 161.656V116.198C394.517 111.904 393.483 108.008 391.416 104.509C389.348 100.851 386.486 97.9887 382.828 95.9213C379.329 93.6947 375.353 92.5815 370.9 92.5815C366.288 92.5815 362.153 93.6947 358.495 95.9213C354.996 97.9887 352.213 100.851 350.146 104.509C348.078 108.008 347.044 111.904 347.044 116.198V161.656C347.044 165.516 343.915 168.645 340.056 168.645L328.556 168.645L317.057 168.645Z",
    fill: "#052973"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 310.068,
    y: 171.641,
    width: 36.9412,
    height: 13.9777,
    rx: 6.98887,
    fill: "#34A853"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 394.936,
    y: 171.639,
    width: 36.9412,
    height: 13.9777,
    rx: 6.98887,
    fill: "#F15B25"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 454.844,
    y: 63.811,
    width: 36.9412,
    height: 36.9412,
    rx: 18.4706,
    fill: "#34A853"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 514.74,
    y: 63.811,
    width: 36.9412,
    height: 13.9777,
    rx: 6.98887,
    fill: "#052973"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 720.404,
    cy: 125.712,
    r: 46.4261,
    stroke: "#F15B25",
    strokeWidth: 32.9475
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M708 110.542L727.384 143L737.373 135.892L731.546 114.332C765.133 98.6249 785.08 90.4635 818 66C805.794 74.0208 728.876 107.708 708 110.542Z",
    fill: "#34A853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M593.131 185.615C582.92 185.615 574.643 177.337 574.643 167.127V99.2575C574.643 88.1249 577.823 79.3778 584.185 73.0163C590.546 66.6549 599.373 63.4741 610.664 63.4741H631.18C639.481 63.4741 646.209 70.2028 646.209 78.5031V78.5031C646.209 86.8034 639.481 93.5321 631.18 93.5321H619.73C617.503 93.5321 615.595 94.3273 614.004 95.9177C612.414 97.349 611.619 99.2575 611.619 101.643V167.127C611.619 177.337 603.341 185.615 593.131 185.615V185.615Z",
    fill: "#052973"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 798,
    cy: 51,
    r: 10.25,
    stroke: "#052973",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M793.229 55.8841V46.9082C793.229 45.7275 793.844 45.3556 794.782 45.3556H799.197C802.351 45.3556 803.192 47.0861 803.192 48.5901C803.192 49.8516 802.448 51.0969 801.186 51.388V51.4204C802.545 51.6145 802.787 52.601 802.787 53.7816C802.787 55.124 803.143 55.6253 803.143 56.1752C803.143 56.7898 802.512 57.2102 801.898 57.2102C800.442 57.2102 800.329 55.8032 800.329 55.3342C800.329 53.2964 799.957 52.4716 798.501 52.4716H795.881V55.8841C795.881 56.6765 795.364 57.2102 794.555 57.2102C793.747 57.2102 793.229 56.6765 793.229 55.8841ZM795.881 47.3933V50.5309H798.534C799.537 50.5309 800.539 50.2721 800.539 48.9621C800.539 47.7168 799.779 47.3933 798.615 47.3933H795.881Z",
    fill: "#052973"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7967 34.5272L104.427 0.850801C107.244 -0.207834 110.117 -0.229622 112.805 0.515011L147.942 184.657C145.715 186.34 143.035 187.378 140.03 187.431L44.2962 189.129C34.3545 189.307 25.0421 184.812 23.2427 175.386L0.283365 55.0578C-1.51606 45.6313 5.48298 38.0261 14.7967 34.5272ZM117.183 2.48617C117.806 2.88348 119.799 4.59704 120.374 5.07252L153.3 177.63C152.94 178.284 151.717 180.611 151.286 181.21L117.183 2.48617ZM120.374 5.07252C122.934 7.66016 124.799 11.0104 125.482 14.5951L154.544 166.901C155.227 170.482 154.727 174.284 153.3 177.63L120.374 5.07252Z",
    fill: "#052973"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1976_11929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.7968 95.3903L92.5965 96.3908C115.372 97.4948 123.21 109.511 125.371 121.775C128.717 140.755 116.905 157.439 87.9969 162.534C57.6288 167.887 41.3745 155.096 39.3673 143.708C38.3379 137.868 41.8514 133.034 47.6914 132.004C60.6854 129.714 60.6728 149.286 84.9089 145.014C97.3189 142.827 102.971 134.755 101.736 127.747C100.99 123.513 98.1225 119.202 89.5862 118.599L61.3666 116.497C38.6347 114.784 32.5826 103.506 30.6011 92.2644C26.4837 68.9043 46.5477 56.3357 66.8418 52.7588C85.5298 49.4649 109.429 56.0911 111.899 70.1072C112.954 76.0932 108.462 80.4979 102.622 81.5272C91.5257 83.4829 90.8162 67.5006 68.4782 71.4379C57.3822 73.3936 52.1508 79.5844 53.4375 86.8845C54.7242 94.1845 63.8959 94.9765 71.7968 95.3903Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1976_11929",
    x: 22.4493,
    y: 44.833,
    width: 108.764,
    height: 129.57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.19913,
    dy: 4.12337
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0818182 0 0 0 0 0.25 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1976_11929"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1976_11929",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLo);
export default __webpack_public_path__ + "static/media/lo.9616b1c5f0ded1f9daa6176a65dcf9af.svg";
export { ForwardRef as ReactComponent };